import React from 'react';
import { ShoppingBag, ArrowUpRight, Star, Download, Award } from 'lucide-react';
import bookImage from './images/george.jpg';

const AMAZON_URL =
  'https://www.amazon.com/Basic-Go-Techniques-kyu-dan/dp/B0GGCLK64M/ref=tmm_hrd_swatch_0';

const BookSection = () => {
  return (
    <section id="book" className="relative py-28 bg-[#0a0a0a] overflow-hidden">
      {/* soft amber radial glow */}
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[700px] h-[700px] rounded-full bg-amber-400/[0.06] blur-[120px] pointer-events-none" />

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Image column */}
          <div className="lg:col-span-5 order-2 lg:order-1">
            <div className="relative mx-auto w-full max-w-[300px] pb-8">
              {/* Glow behind */}
              <div className="absolute -inset-6 bg-amber-400/20 rounded-3xl blur-3xl" />

              {/* Image frame with book-cover aspect ratio */}
              <div
                className="relative aspect-[5/8] rounded-2xl overflow-hidden border border-amber-400/30 shadow-[0_30px_80px_-15px_rgba(0,0,0,0.9),0_0_60px_-20px_rgba(245,180,68,0.5)] transform-gpu transition-transform duration-700 hover:scale-[1.02]"
                style={{
                  transform: 'perspective(1400px) rotateY(-6deg) rotateX(2deg)',
                }}
              >
                <img
                  src={require('./images/bookfinal.jpg')}
                  alt="The book published on Amazon"
                  className="absolute inset-0 w-full h-full object-contain bg-black"
                />
                {/* Top sheen */}
                <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/[0.04] to-transparent pointer-events-none" />
              </div>

              {/* Floating badge */}
              <div className="absolute bottom-0 left-1/2 -translate-x-1/2 z-20">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-400 text-[#0a0a0a] text-[11px] font-semibold tracking-wider shadow-lg shadow-amber-400/30 whitespace-nowrap">
                  <Award size={13} strokeWidth={2.5} />
                  AVAILABLE ON AMAZON
                </div>
              </div>
            </div>
          </div>

          {/* Content column */}
          <div className="lg:col-span-7 order-1 lg:order-2">
            <p className="text-amber-400 tracking-[0.32em] text-[12px] mb-5 font-medium">
              THE BOOK
            </p>
            <h2 className="font-serif text-white text-4xl sm:text-5xl lg:text-[58px] leading-[1.05] tracking-tight">
              Now published on <span className="text-amber-400 italic">Amazon</span>
            </h2>

            <p className="mt-6 text-white/70 text-[16.5px] leading-[1.8] max-w-xl">
              Years of teaching distilled into a single book, practical techniques, real game
              examples, and the same lessons I use with my private students. Written for kyu
              players hungry to break through into dan level.
            </p>

            {/* Highlights */}
            <ul className="mt-8 grid sm:grid-cols-2 gap-x-8 gap-y-3">
              {[
                'Basic Go techniques explained clearly',
                'From kyu through dan level',
                'Real positions from 8 Dan play',
                'Strategy that actually transfers to games',
              ].map((item) => (
                <li key={item} className="flex items-start gap-3 text-white/75 text-[14.5px]">
                  <Star
                    size={14}
                    fill="currentColor"
                    strokeWidth={0}
                    className="text-amber-400 mt-1 shrink-0"
                  />
                  {item}
                </li>
              ))}
            </ul>

            {/* CTAs */}
            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <a
                href={AMAZON_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center justify-center gap-3 bg-amber-400 hover:bg-amber-300 text-[#0a0a0a] pl-7 pr-6 py-4 rounded-full text-[15px] font-semibold transition-all duration-300 shadow-[0_0_40px_-10px_rgba(245,180,68,0.6)] hover:shadow-[0_0_60px_-8px_rgba(245,180,68,0.85)]"
              >
                <ShoppingBag size={18} strokeWidth={2} />
                Get the book on Amazon
                <ArrowUpRight
                  size={18}
                  className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
                />
              </a>
              <a
                href="#contact"
                className="inline-flex items-center justify-center gap-3 px-6 py-4 rounded-full border border-amber-400/50 text-amber-400 hover:bg-amber-400 hover:text-[#0a0a0a] transition-colors duration-300 text-[15px] font-medium"
              >
                <Download size={17} />
                Request a free sample
              </a>
            </div>

            <p className="mt-5 text-white/45 text-[13px]">
              Ships worldwide via Amazon. Kindle &amp; paperback available.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookSection;
